module.exports = __webpack_public_path__ + "img/li.748d1f99.svg";